import React from 'react'
import PropTypes from 'prop-types'
import { Spin, Modal, Form, Input, DatePicker, Button } from 'antd'
import { IMaskInput } from 'react-imask'
import moment from 'moment' // Добавляем импорт moment

import axios from 'axios'

import LastOrder from './../block/LastOrder'
import AkciiSlyder from './../block/AkciiSlyder'
import Footer from './../block/Footer'
import ProductCard from './../block/ProductCard'

import { Close } from './../block/Svg'

// SVG компоненты
const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.332 1.333H5.999C2.665 1.333 1.332 2.667 1.332 6v4c0 3.334 1.333 4.667 4.667 4.667h4c3.333 0 4.666-1.333 4.666-4.667V8.667"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M10.693 2.013 5.44 7.266c-.2.2-.4.594-.44.88l-.287 2.007c-.106.727.407 1.233 1.134 1.133L7.853 11c.28-.04.674-.24.88-.44l5.254-5.254c.906-.906 1.333-1.96 0-3.293-1.334-1.333-2.387-.907-3.294 0Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M9.941 2.767a4.763 4.763 0 0 0 3.294 3.293"
    />
  </svg>
)

const ArrowRightIcon = () => (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 9L5 5L1 1" stroke="black" strokeOpacity="0.6"/>
  </svg>
)

const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.25}
      d="m12.533 10.184 2.133-2.133-2.133-2.134M6.135 8.05h8.475M7.801 14.666c-3.683 0-6.666-2.5-6.666-6.667 0-4.166 2.983-6.666 6.666-6.666"
    />
  </svg>
)

const CoinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={21} fill="none">
    <path
      fill="#fff"
      d="M8.445 1.95c4.664 0 8.445 3.828 8.445 8.55 0 4.722-3.78 8.55-8.445 8.55C3.781 19.05 0 15.222 0 10.5c0-4.722 3.781-8.55 8.445-8.55ZM4.99 8.825c-1.306 0-2.383 1.048-2.384 2.34 0 1.293 1.078 2.341 2.384 2.341a2.338 2.338 0 0 0 2.348-2.34c0-1.293-1.041-2.34-2.348-2.34Zm3.503-1.28a.722.722 0 0 0-.722.722v4.516a.723.723 0 0 0 1.445 0v-1.18l1.32 1.655a.659.659 0 0 0 1.05-.791l-.998-1.411.887-1.163a.574.574 0 1 0-.914-.694l-1.345 1.784V8.267a.722.722 0 0 0-.723-.722ZM12.9 8.971c-.359 0-.65.296-.65.66v3.217c0 .363.291.658.65.658.36 0 .65-.295.65-.658V9.63a.655.655 0 0 0-.65-.66Zm-7.91 1.098c.561 0 1.01.49 1.011 1.096 0 .607-.45 1.098-1.012 1.098s-1.048-.49-1.048-1.098c0-.607.486-1.096 1.048-1.096Zm8.906-3.329c-.317-.606-.762.031-.962.391-.2-.36-.663-.997-.98-.39-.318.608.505 1.474.972 1.845.467-.371 1.288-1.238.97-1.846Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.9}
      d="M8.445 1.95V1M8.445 20v-.95"
    />
  </svg>
)

const DotIcon = () => (
  <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="1.5" cy="1.5" r="1.5" fill="#5A91FF"/>
  </svg>
)

const HeartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={12} fill="none">
    <path
      fill="#F66116"
      d="M10.401 11.587a.965.965 0 0 1-.471-.31c-.847-1.112-2.246-4.35-.444-7.089.796-1.21 2.386-1.565 3.553-.798a2.486 2.486 0 0 1 1.11 1.987 2.493 2.493 0 0 1 2.264.233c1.167.768 1.47 2.369.674 3.578-1.803 2.74-5.329 2.737-6.686 2.4Z"
    />
    <path
      fill="#000"
      fillOpacity={0.2}
      d="M10.401 11.587a.965.965 0 0 1-.471-.310c-.847-1.112-2.246-4.35-.444-7.089.796-1.21 2.386-1.565 3.553-.798a2.486 2.486 0 0 1 1.11 1.987 2.493 2.493 0 0 1 2.264.233c1.167.768 1.47 2.369.674 3.578-1.803 2.74-5.329 2.737-6.686 2.4Z"
    />
    <path
      fill="#F66116"
      d="M6.372 10.944c-.204.074-.54.074-.744 0C3.888 10.333 0 7.78 0 3.454 0 1.544 1.494 0 3.336 0 4.428 0 5.394.544 6 1.384A3.288 3.288 0 0 1 8.664 0C10.506 0 12 1.545 12 3.454c0 4.326-3.888 6.879-5.628 7.49Z"
    />
  </svg>
)

// Компонент уведомления об ошибке
const ErrorNotification = ({ message, onClose, visible }) => {
  if (!visible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm">
      <div className="bg-white rounded-lg shadow-lg border border-red-100 p-4 flex items-start gap-3">
        <div className="w-5 h-5 rounded-full bg-red-500 flex items-center justify-center flex-shrink-0 mt-0.5">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="white" strokeWidth="0.5"/>
            <path d="M6 4V6.5" stroke="white" strokeWidth="0.5" strokeLinecap="round"/>
            <path d="M6 8H6.005" stroke="white" strokeWidth="0.5" strokeLinecap="round"/>
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900 mb-1">Ошибка</p>
          <p className="text-sm text-gray-600">{message}</p>
        </div>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L13 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M13 13L1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

ErrorNotification.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func,
  visible: PropTypes.bool
};

ErrorNotification.defaultProps = {
  message: 'Произошла ошибка',
  visible: false
};

// Компонент уведомления об успехе
const SuccessNotification = ({ message, onClose, visible }) => {
  if (!visible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm">
      <div className="bg-white rounded-lg shadow-lg border border-green-100 p-4 flex items-start gap-3">
        <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0 mt-0.5">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900 mb-1">Успешно</p>
          <p className="text-sm text-gray-600">{message}</p>
        </div>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L13 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M13 13L1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

SuccessNotification.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func,
  visible: PropTypes.bool
};

SuccessNotification.defaultProps = {
  message: 'Операция выполнена успешно',
  visible: false
};

const Pconf = () => (
  <svg className='flex-none' xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <circle cx={8} cy={8} r={8} fill="#5A91FF" fillOpacity={0.5} />
    <circle cx={8} cy={8} r={5} fill="#5A91FF" />
  </svg>
)

// Компонент модального окна подтверждения выхода
const LogoutConfirmationModal = ({ show, close, onConfirm }) => {
  return (
    <div className={`bg-[#00000066] backdrop-blur-[51.4px] z-[60] fixed top-0 w-[100%] h-dvh transition-all duration-300 ease-in-out ${show ? ` left-0` : ` left-[-100%]`}`}>
      <div className='container h-dvh flex flex-col tracking-tight px-[20px]'>
        <div className="flex justify-between items-center mt-[20px]">
          <button 
            onClick={close}
            className="w-[40px] h-[40px] rounded-full bg-[#F6F6F6] flex items-center justify-center flex-none text-black"
          >
            <Close />
          </button>
          <div></div>
        </div>
        <div className='flex flex-1 items-center justify-center flex-col mb-[60px] px-[10px]'>
          <div className='w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4'>
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </div>
          
          <div className='text-white text-center text-[22px] mb-[3px]'>Выйти из аккаунта?</div>
          <div className='text-[#FFFFFF99] text-center text-[14px] mb-[19px]'>
            Вы действительно хотите выйти из своего аккаунта?<br />
            Для входа потребуется снова ввести данные.
          </div>

          <div className='flex gap-3 w-full'>
            <button
              onClick={close}
              className="flex-1 py-3 px-4 border border-gray-300 text-white rounded-2xl font-medium transition-colors"
            >
              Отмена
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 py-3 px-4 bg-red-500 text-white rounded-2xl font-medium hover:bg-red-600 transition-colors"
            >
              Выйти
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

LogoutConfirmationModal.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func,
  onConfirm: PropTypes.func
};

// Компонент модального окна удаления аккаунта
const DeleteAccountModal = ({ show, close, assets_path, onSend }) => {
  const [text, setText] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleSend = () => {
    if (!text.trim()) {
      return;
    }
    setLoading(true);
    onSend(text.trim(), () => {
      setLoading(false);
      setText('');
    });
  };

  return (
    <div className={`bg-[#00000066] backdrop-blur-[51.4px] z-[60] fixed top-0 w-[100%] h-dvh transition-all duration-300 ease-in-out ${show ? ` left-0` : ` left-[-100%]`}`}>
      <div className='container h-dvh flex flex-col tracking-tight px-[20px]'>
        <div className="flex justify-between items-center mt-[20px]">
          <button 
            onClick={() => close()}
            className="w-[40px] h-[40px] rounded-full bg-[#F6F6F6] flex items-center justify-center flex-none text-black"
            disabled={loading}
          >
            <Close />
          </button>
          <div></div>
        </div>
        <div className='flex flex-1 items-center justify-center flex-col mb-[60px] px-[10px]'>
          <div className='text-white text-center text-[22px] mb-[3px]'>Удаление аккаунта</div>
          <div className='text-[#FFFFFF99] text-center text-[14px] mb-[19px]'>
            Опишите причину удаления аккаунта.<br />
            Наш менеджер свяжется с вами для подтверждения.
          </div>
          <textarea
            name="text"
            placeholder="Опишите причину удаления аккаунта"
            value={text}
            onChange={(e) => setText(e.target.value)}
            className='text-[#00000099] pl-[33px] text-[16px] p-[10px] rounded-[20px] bg-[#F6F6F6] border-[#F6F6F6] mb-[10px] h-[86px] w-[100%]'
            disabled={loading}
            style={{
              backgroundImage: `url(/${assets_path}/images/messages.svg)`,
              backgroundPosition: `10px 10px`,
              backgroundRepeat: `no-repeat`
            }}
          />
          <button
            onClick={handleSend}
            disabled={loading || !text.trim()}
            className='text-white text-[16px] cursor-pointer flex items-center justify-center h-[38px] w-[100%] bg-[#FF5A5A] rounded-full mb-[10px] disabled:opacity-50 disabled:cursor-not-allowed'
          >
            {loading ? 'Отправка...' : 'Отправить запрос на удаление'}
          </button>
          <div className='flex gap-[6px] cursor-pointer'>
            <Pconf />
            <div className='text-[#FFFFFF99] text-[12px]'>Нажимая на кнопку, вы соглашаетесь с политикой конфиденциальности</div>
          </div>
        </div>
      </div>
    </div>
  );
};

DeleteAccountModal.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func,
  assets_path: PropTypes.string,
  onSend: PropTypes.func
};

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditModalVisible: false,
      isDeleteAccountModalVisible: false,
      isLogoutModalVisible: false, // Добавляем состояние для модалки выхода
      loading: false,
      phone: props.user?.phone || '',
      birthday: props.user?.dob ? moment(props.user.dob) : null, // Преобразуем строку в moment объект
      errorNotification: {
        visible: false,
        message: ''
      },
      successNotification: {
        visible: false,
        message: ''
      }
    }
    this.formRef = React.createRef()
  }

  logout() {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'logout'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      if (response.data?.result) {
        window.location.href = '/'
      }
    }).catch((error) => {
      console.error('Error logout:', error)
    })
  }

  getOrderWord(count) {
    if (count % 10 === 1 && count % 100 !== 11) {
      return 'заказ'
    } else if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
      return 'заказа'
    } else {
      return 'заказов'
    }
  }

  getProductWord(count) {
    if (count % 10 === 1 && count % 100 !== 11) {
      return 'товар'
    } else if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
      return 'товара'
    } else {
      return 'товаров'
    }
  }

  showEditModal = () => {
    this.setState({ isEditModalVisible: true })
    setTimeout(() => {
      if (this.formRef.current) {
        const { user } = this.props
        this.formRef.current.setFieldsValue({
          fullname: user?.fullname || '',
          email: user?.email || '',
          phone: user?.phone || '',
          birthday: user?.dob ? moment(user.dob) : null // Преобразуем строку в moment объект
        })
        this.setState({ phone: user?.phone || '' })
      }
    }, 0)
  }

  handleEditCancel = () => {
    this.setState({ isEditModalVisible: false })
  }

  handleEditSave = () => {
    this.formRef.current.validateFields().then(values => {
      this.setState({ loading: true })
      
      // Форматируем дату рождения для отправки
      const formData = {
        ...values,
        phone: this.state.phone,
        birthday: values.birthday ? values.birthday.format('YYYY-MM-DD') : null
      }

      // Вызываем функцию сохранения данных профиля
      this.saveProfileData(formData)
    }).catch(error => {
      console.error('Validation failed:', error)
    })
  }

  handlePhoneChange = (value) => {
    this.setState({ phone: value })
    // Также обновляем значение в форме
    if (this.formRef.current) {
      this.formRef.current.setFieldsValue({
        phone: value
      })
    }
  }

  saveProfileData = ( formData ) => {
    const { save } = this.props

    save(formData, () => {
      this.setState({ 
        loading: false,
        isEditModalVisible: false 
      })
    })
  }

  repeatOrder = ( id ) => {
    const main = this,
    { data } = this.props

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'repeat_order',
      id: id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if(response?.data?.result) window.location = data?.cart_link
    })
    .catch((error) => {
      console.error('Ошибка запроса:', error);
    })
  }

  // Функции для управления модальным окном выхода
  showLogoutModal = () => {
    this.setState({ isLogoutModalVisible: true })
  }

  hideLogoutModal = () => {
    this.setState({ isLogoutModalVisible: false })
  }

  confirmLogout = () => {
    this.logout();
    this.hideLogoutModal();
  }

  // Функции для управления модальным окном удаления аккаунта
  showDeleteAccountModal = () => {
    this.setState({ isDeleteAccountModalVisible: true })
  }

  hideDeleteAccountModal = () => {
    this.setState({ isDeleteAccountModalVisible: false })
  }

  // Функции для уведомлений
  showErrorNotification = (message) => {
    this.setState({
      errorNotification: {
        visible: true,
        message: message || 'Произошла ошибка'
      }
    });

    setTimeout(() => {
      this.hideErrorNotification();
    }, 5000);
  };

  hideErrorNotification = () => {
    this.setState({
      errorNotification: {
        visible: false,
        message: ''
      }
    });
  };

  showSuccessNotification = (message) => {
    this.setState({
      successNotification: {
        visible: true,
        message: message || 'Сообщение отправлено успешно'
      }
    });

    setTimeout(() => {
      this.hideSuccessNotification();
    }, 5000);
  };

  hideSuccessNotification = () => {
    this.setState({
      successNotification: {
        visible: false,
        message: ''
      }
    });
  };

  // Функция отправки запроса на удаление аккаунта
  sendDeleteAccountRequest = (text, callback) => {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'delete_account_request',
      text: text
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      callback();
      this.showSuccessNotification('Ваш запрос на удаление аккаунта успешно отправлен! Мы свяжемся с вами для подтверждения.');
      this.hideDeleteAccountModal();
    })
    .catch((error) => {
      callback();
      let errorMessage = 'Произошла ошибка при отправке запроса';
      
      if (error.response) {
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        errorMessage = 'Не удалось подключиться к серверу';
      }
      
      this.showErrorNotification(errorMessage);
      console.error('Ошибка запроса:', error);
    });
  }

  render() {
    const {
      lastOrder,
      data,
      showFeedbackForm,
      assets_path,
      user,
      restaurant,
      lk_data,
      tpl,
      favorite,
      changeFavorite,
      openProductWin,
      cart,
      leftMenu
    } = this.props

    const { 
      isEditModalVisible, 
      isDeleteAccountModalVisible,
      isLogoutModalVisible, // Добавляем в деструктуризацию
      loading, 
      phone,
      errorNotification,
      successNotification
    } = this.state

    const statuses = {
      new: {
        image: 1,
        name: `В обработке`,
        text: `Скоро начнем готовить заказ`,
        color: `#5A91FF`
      },
      sent: {
        image: 1,
        name: `В обработке`,
        text: `Скоро начнем готовить заказ`,
        color: `#5A91FF`
      },
      error: {
        image: 2,
        name: `Заказ отменен`,
        text: `Упс, что-то пошло не так`,
        color: `#3A3A3A`
      },
      jupiter_new: {
        image: 1,
        name: `В обработке`,
        text: `Скоро начнем готовить заказ`,
        color: `#5A91FF`
      },
      cancelled: {
        image: 2,
        name: `Заказ отменен`,
        text: `Упс, что-то пошло не так`,
        color: `#3A3A3A`
      },
      preparing: {
        image: 3,
        name: `Готовим для вас`,
        text: `Заказ готовится к отправке`,
        color: `#5A91FF`
      },
      ready: {
        image: 4,
        name: `Заказ готов`,
        text: `Передаем в доставку курьером`,
        color: `#F66116`
      },
      ontheway: {
        image: 5,
        name: `Заказ у курьера`,
        text: `Мы позвоним по прибытии`,
        color: `#A6DD2F`
      },
      delivered: {
        image: 6,
        name: `Заказ доставлен`,
        text: `Приятного аппетита!`,
        color: `#A6DD2F`
      }
    }

    return (
      <div
        className='bg-cover bg-center bg-no-repeat'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <div className='container font-manrope tracking-tight min-h-dvh flex flex-col overflow-x-hidden'>
          <div className='flex items-center justify-between pt-[10px]'>
            <div className='w-[92px]'>
              <a href="/" className="flex-none w-[40px] h-[40px] rounded-full bg-white flex items-center justify-center cursor-pointer">
                <Close />
              </a>
            </div>
            <div className='text-center font-manrope text-[22px] text-black font-semibold'>
              Профиль
            </div>
            <div onClick={() => showFeedbackForm()} className="flex-none gap-[7px] w-[92px] h-[40px] rounded-full bg-white flex items-center justify-center cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.8534 12.6225L14.1459 14.9925C14.2209 15.615 13.5534 16.05 13.0209 15.7275L9.87836 13.86C9.53336 13.86 9.19587 13.8375 8.86587 13.7925C9.42087 13.14 9.75086 12.315 9.75086 11.4225C9.75086 9.29249 7.90586 7.56752 5.62586 7.56752C4.75586 7.56752 3.95337 7.815 3.28587 8.25C3.26337 8.0625 3.25586 7.87499 3.25586 7.67999C3.25586 4.26749 6.21836 1.5 9.87836 1.5C13.5384 1.5 16.5009 4.26749 16.5009 7.67999C16.5009 9.70499 15.4584 11.4975 13.8534 12.6225Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9.75 11.4225C9.75 12.315 9.42001 13.14 8.86501 13.7925C8.12251 14.6925 6.945 15.27 5.625 15.27L3.6675 16.4325C3.3375 16.635 2.9175 16.3575 2.9625 15.975L3.15 14.4975C2.145 13.8 1.5 12.6825 1.5 11.4225C1.5 10.1025 2.205 8.93998 3.285 8.24998C3.9525 7.81498 4.755 7.5675 5.625 7.5675C7.905 7.5675 9.75 9.29247 9.75 11.4225Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div className='text-[14px] text-black'>Связь</div>
            </div>
          </div>
          <LastOrder
            order={lastOrder}
            assets_path={assets_path}
          />
          <div className='w-[100%] h-[60px] bg-white rounded-full flex items-center p-[10px] mt-[10px] gap-[8px]'>
            <img src={`/${assets_path}/images/user.svg`} width='40' height='40' alt='user' />
            <div>
              <div className='text-[18px] text-black font-medium line-clamp-1'>{user?.fullname}</div>
              <div className='text-[#00000099] text-[14px]'>{user?.phone}</div>
            </div>
            <div 
              onClick={this.showEditModal}
              className='w-[117px] h-[40px] rounded-full bg-[#F6F6F6] flex items-center gap-[8px] cursor-pointer ml-auto justify-center'
            >
              <div className="flex-none w-[30px] h-[30px] rounded-full bg-white flex items-center justify-center cursor-pointer">
                <EditIcon />
              </div>
              <div className='text-[16px] text-black'>Изменить</div>
            </div>
          </div>
          <div className='mt-[10px] flex items-center gap-[5px]'>
            <a target="_blank" href={data?.urinfo_link} className='w-[auto] h-[40px] flex-1 rounded-full bg-[#FFFFFF] flex items-center gap-[8px] cursor-pointer ml-auto justify-between px-[15px]'>
              <div className='text-[#00000099] font-medium text-[12px] line-clamp-1'>Юридическая информация</div>
              <ArrowRightIcon />
            </a>
            {/* Заменяем ссылку на кнопку с обработчиком */}
            <button 
              onClick={this.showLogoutModal}
              className='w-[98px] h-[40px] rounded-full bg-[#5A91FF] flex items-center gap-[8px] cursor-pointer ml-auto justify-center'
            >
              <div className='text-white font-medium text-[16px]'>Выйти</div>
              <LogoutIcon />
            </button>
          </div>

          {lk_data?.loaded ?
            <div className='mt-[15px] flex items-center justify-start gap-[5px] overflow-x-auto scroll-bar-custom'>
              <div
                className='w-[125px] h-[166px] flex-none bg-cover bg-center bg-no-repeat p-[10px] flex items-end justify-start rounded-[20px]'
                style={{ backgroundImage: `url(/${assets_path}/images/coincardbg.svg)` }}
              >
                <div>
                  <div className='text-[14px] text-[#FFFFFF99] leading-none'>Всего <br />бонусов:</div>
                  <div className='flex gap-[4px] items-center'>
                    <div className='text-[28px] text-white font-semibold'>{user?.coin}</div>
                    <CoinIcon />
                  </div>
                  <div className='px-[8px] flex items-center h-[20px] bg-[#FFFFFF4D] rounded-full text-white font-medium text-[14px]'>Оки-коины</div>
                </div>
              </div>
              {lk_data?.total_orders > 0 &&
                <a href={data?.history_link} className='w-[125px] h-[166px] flex-none bg-white p-[10px] flex items-start justify-between flex-col rounded-[20px]'>
                  <div className='h-[40px] flex'>
                    {lk_data?.images.map( ( src, k ) => {
                      if(k < 5) return (
                        <div className={`flex items-center justify-center bg-[#F6F6F6] rounded-full w-[40px] h-[40px] ${k > 0 && `ml-[-9px]`}`}>
                          <img src={src} width={30} alt={`${k}`} />
                        </div>
                      )
                    })}
                  </div>
                  <div className='text-[14px] text-[#00000099] leading-none'>
                    Доставили <br />
                    последний заказ
                  </div>
                  <div className='flex items-center gap-[5px] text-black text-[12px] whitespace-nowrap'>
                    <div>{lk_data?.updatedon}</div>
                    <DotIcon />
                    <div>{lk_data?.final_amount} ₽</div>
                  </div>
                  <div className='text-black text-[18px] font-semibold'>Мои заказы</div>
                  <div className='px-[8px] flex items-center h-[20px] bg-[#5A91FF] rounded-full text-white font-medium uppercase text-[10px]'>{lk_data?.total_orders} {this.getOrderWord(lk_data?.total_orders)}</div>
                </a>
              }
              <a href={data?.favorite_link} className='w-[125px] h-[166px] flex-none bg-white p-[10px] flex items-start justify-between flex-col rounded-[20px]'>
                <div className='h-[40px] flex'>
                  {lk_data?.image != '' &&
                    <div className='flex items-center justify-center bg-[#F6F6F6] w-[40px] h-[40px] rounded-full relative'>
                      <img src={lk_data?.image} width={30} alt={`f`} />
                      <div className='absolute right-[-12px] bottom-[1px]'>
                        <HeartIcon />
                      </div>
                    </div>
                  }
                </div>
                <div className='text-[14px] text-[#00000099] leading-none'>
                  Избранное <br />
                  в одном месте
                </div>
                <div className='text-black text-[18px] font-semibold leading-none'>
                  Любимые <br />
                  товары
                </div>
                <div className='px-[8px] flex items-center h-[20px] bg-[#5A91FF] rounded-full text-white font-medium uppercase text-[10px]'>{lk_data?.favorite || 0} {this.getProductWord(lk_data?.favorite)}</div>
              </a>
            </div>
          :
            <div className='mt-[15px] flex items-center justify-center h-[166px]'>
              <Spin />
            </div>
          }
          {tpl == 'main' &&
            <>
              <div className='mt-[15px] text-center text-black text-[18px] font-semibold'>Акции</div>
              <AkciiSlyder
                slydes={restaurant?.akcii || []}
                full={true}
              />
            </>
          }
          {tpl == 'history' &&
            <>
              <div className='mt-[15px] text-center text-black text-[18px] font-semibold'>Мои заказы</div>
              {lk_data?.loaded ?
                <>
                  {lk_data?.orders?.length > 0 ? (
                    <div className="space-y-4 mt-[20px]">
                      {lk_data.orders.map((order) => (
                        <div key={order.id} className="bg-white rounded-lg shadow-md p-4 border">
                          {/* Заголовок заказа */}
                          <div className="flex justify-between items-start mb-3">
                            <div>
                              <div className="text-lg font-semibold">Заказ #{order.order_number}</div>
                              <div className="text-sm text-gray-500">
                                {new Date(order.createdon).toLocaleDateString('ru-RU', {
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                })}
                              </div>
                            </div>
                            <div className="text-right">
                              <div className="text-lg font-bold">{order.final_amount} ₽</div>
                              <div 
                                className="text-sm font-medium px-2 py-1 rounded-full"
                                style={{ color: statuses[order.current_status]?.color || '#5A91FF' }}
                              >
                                {statuses[order.current_status]?.name || 'В обработке'}
                              </div>
                            </div>
                          </div>

                          {/* Список товаров */}
                          <div className="border-t pt-3">
                            <div className="text-sm font-medium mb-2">Состав заказа:</div>
                            <div className="space-y-2">
                              {order.cart_json?.items?.map((item, index) => (
                                <div key={index} className="flex justify-between text-sm">
                                  <div className="flex-1">
                                    <span className="font-medium">{item.pagetitle}</span>
                                    {item.ingredients && item.ingredients.filter( ing => !ing.anti ).length > 0 && (
                                      <div className="text-xs text-gray-500 mt-1">
                                        Дополнительно: {item.ingredients.filter( ing => !ing.anti ).map(ing => ing.name).join(', ')}
                                      </div>
                                    )}
                                    {item.ingredients && item.ingredients.filter( ing => ing.anti ).length > 0 && (
                                      <div className="text-xs text-gray-500 mt-1">
                                        Убрать: {item.ingredients.filter( ing => ing.anti ).map(ing => ing.name).join(', ')}
                                      </div>
                                    )}
                                  </div>
                                  <div className="ml-4 text-right whitespace-nowrap">
                                    <div>{item.quantity}шт.</div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Способ доставки */}
                          <div className="border-t pt-3 mt-3 text-sm">
                            <div className="flex justify-between">
                              <span>Способ получения:</span>
                              <span className="font-medium">
                                {order.delivery_method === 'courier' ? 'Доставка курьером' : 'Самовывоз'}
                              </span>
                            </div>
                            {order.delivery_method === 'courier' && order.delivery_address && (
                              <div className="text-gray-600 mt-1">Адрес: {order.delivery_address}</div>
                            )}
                          </div>
                          {order?.date_preorder != '' &&
                            <div className="border-t pt-3 mt-3 text-sm">
                              <div className="flex justify-between">
                                <span>Предзаказ:</span>
                                <span className="font-medium">
                                  {order?.date_preorder}
                                </span>
                              </div>
                            </div>
                          }
                          {['delivered', 'error', 'cancelled'].includes(order?.current_status) &&
                            <Button
                              onClick={() => this.repeatOrder( order.id )}
                              size="large"
                              className="mt-[10px] w-full p-[5px] h-10 rounded-full text-[14px] font-inter bg-[#F6F6F6] border-[#F6F6F6] text-black flex items-center justify-between gap-2"
                            >
                              <div className='w-[30px] h-[30px] rounded-full bg-[#FFFFFF] flex items-center justify-center'>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M17.3346 9.00008C17.3346 13.6001 13.6013 17.3334 9.0013 17.3334C4.4013 17.3334 1.59297 12.7001 1.59297 12.7001M1.59297 12.7001H5.35964M1.59297 12.7001V16.8667M0.667969 9.00008C0.667969 4.40008 4.36797 0.666748 9.0013 0.666748C14.5596 0.666748 17.3346 5.30008 17.3346 5.30008M17.3346 5.30008V1.13341M17.3346 5.30008H13.6346" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </div>
                              <div>Повторить заказ</div>
                              <div className='w-[30px] h-[30px]'></div>
                            </Button>
                          }
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-500">
                      У вас пока нет заказов
                    </div>
                  )}
                </>
              :
                <div className='mt-[15px] flex items-center justify-center h-[166px]'>
                  <Spin />
                </div>
              }
            </>
          }
          {tpl == 'favorite' &&
            <>
              {lk_data?.loaded ?
                <div className='mt-[20px]'>
                  {lk_data?.fav_arr.map( (elm, k) => (
                    <ProductCard
                      elm={elm}
                      key={k}
                      favorite={favorite}
                      changeFavorite={changeFavorite}
                      openProductWin={openProductWin}
                    />
                  ))}
                </div>
              :
                <div className='mt-[15px] flex items-center justify-center h-[166px]'>
                  <Spin />
                </div>
              }
            </>
          }

          {/* Кнопка удаления аккаунта */}
          <div className='mt-[10px]'>
            <button 
              onClick={this.showDeleteAccountModal}
              className='w-full h-[30px] rounded-full bg-[#FF5A5A] flex items-center justify-center cursor-pointer'
            >
              <div className='text-white font-medium text-[12px]'>Удалить аккаунт</div>
            </button>
          </div>

          <div className='w-[100%] h-[90px]' />
          <Footer
            showFeedbackForm={showFeedbackForm}
            data={data}
            cart={cart}
            leftMenu={leftMenu}
          />

          {/* Модальное окно редактирования профиля */}
          <Modal
            title="Редактирование профиля"
            open={isEditModalVisible}
            onCancel={this.handleEditCancel}
            footer={[
              <button 
                key="save" 
                onClick={this.handleEditSave}
                disabled={loading}
                className="px-4 py-2 w-[100%] rounded-full bg-[#5A91FF] text-white hover:bg-blue-600 disabled:opacity-50"
              >
                {loading ? 'Сохранение...' : 'Сохранить'}
              </button>
            ]}
            className="profile-edit-modal"
          >
            <Form
              ref={this.formRef}
              layout="vertical"
              className="mt-4"
            >
              <Form.Item
                label="Имя"
                name="fullname"
                rules={[
                  { required: true, message: 'Пожалуйста, введите ваше имя' }
                ]}
              >
                <Input 
                  placeholder="Введите ваше имя" 
                  size="large"
                  className="rounded-full px-4"
                />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
              >
                <Input 
                  placeholder="Введите ваш email" 
                  size="large"
                  className="rounded-full px-4"
                />
              </Form.Item>

              <Form.Item
                label="Телефон"
                name="phone"
              >
                <IMaskInput
                  mask="+7 000 000-00-00"
                  value={phone}
                  onAccept={this.handlePhoneChange}
                  placeholder="+7 999 999-99-99"
                  style={{
                    width: '100%',
                    height: '40px',
                    borderRadius: '20px',
                    padding: '0 16px',
                    border: '1px solid #d9d9d9',
                    fontSize: '16px'
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Дата рождения"
                name="birthday"
              >
                <DatePicker 
                  format="DD.MM.YYYY"
                  placeholder="Выберите дату рождения"
                  className="w-full rounded-full"
                  size="large"
                />
              </Form.Item>
            </Form>
          </Modal>

          {/* Модальное окно подтверждения выхода */}
          <LogoutConfirmationModal
            show={isLogoutModalVisible}
            close={this.hideLogoutModal}
            onConfirm={this.confirmLogout}
          />

          {/* Модальное окно удаления аккаунта */}
          <DeleteAccountModal
            show={isDeleteAccountModalVisible}
            close={this.hideDeleteAccountModal}
            assets_path={assets_path}
            onSend={this.sendDeleteAccountRequest}
          />

          {/* Уведомления */}
          <ErrorNotification
            visible={errorNotification.visible}
            message={errorNotification.message}
            onClose={this.hideErrorNotification}
          />
          
          <SuccessNotification
            visible={successNotification.visible}
            message={successNotification.message}
            onClose={this.hideSuccessNotification}
          />
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  assets_path: PropTypes.string,
  data: PropTypes.object,
  showFeedbackForm: PropTypes.func,
  lastOrder: PropTypes.object,
  user: PropTypes.object,
  restaurant: PropTypes.object,
  lk_data: PropTypes.object,
  save: PropTypes.func,
  tpl: PropTypes.string,
  favorite: PropTypes.string,
  changeFavorite: PropTypes.func,
  openProductWin: PropTypes.func,
  cart: PropTypes.object,
  leftMenu: PropTypes.func
}

export default Main